"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const portal_intl_icu_de_yaml_1 = __importDefault(require("../../../translations/portal+intl-icu.de.yaml"));
const portal_intl_icu_en_yaml_1 = __importDefault(require("../../../translations/portal+intl-icu.en.yaml"));
const portal_intl_icu_es_yaml_1 = __importDefault(require("../../../translations/portal+intl-icu.es.yaml"));
const portal_intl_icu_fr_yaml_1 = __importDefault(require("../../../translations/portal+intl-icu.fr.yaml"));
const portal_intl_icu_it_yaml_1 = __importDefault(require("../../../translations/portal+intl-icu.it.yaml"));
const portal_intl_icu_nl_yaml_1 = __importDefault(require("../../../translations/portal+intl-icu.nl.yaml"));
const translation_1 = __importDefault(require("../../common/js/setup/translation"));
const Languages_1 = require("../constants/Languages");
(0, translation_1.default)({
    de: {
        translation: portal_intl_icu_de_yaml_1.default,
    },
    en: {
        translation: portal_intl_icu_en_yaml_1.default,
    },
    es: {
        translation: portal_intl_icu_es_yaml_1.default,
    },
    fr: {
        translation: portal_intl_icu_fr_yaml_1.default,
    },
    it: {
        translation: portal_intl_icu_it_yaml_1.default,
    },
    nl: {
        translation: portal_intl_icu_nl_yaml_1.default,
    },
}, Languages_1.DEFAULT_LANGUAGE);
